<template>
  <Layout
    :errors="errors"
    :title="trans(`models.settings.content.edit.action`)"
    :toasts="toasts"
    :resource="model"
  >
    <template #top>
      <resource-action-header
        :model="model"
        :action="'edit'"
        :description="model.data.attributes.description"
      ></resource-action-header>
    </template>
    <ul class="nav nav-tabs gap-1" style="margin: 0 0 -1px 0.5rem">
      <li class="nav-item" v-for="(settingGroup, key) in $page.props.settingGroups" :key="key">
        <Link
          :href="route(`${routePrefix}.setting-groups.edit`, { id: settingGroup.id })"
          :class="model.data.id === settingGroup.id ? 'active' : 'text-muted'"
          class="nav-link"
        >
          <colored-icon
            :icon-class="settingGroup.icon_class"
            :color="settingGroup.icon_color"
            :shadow="false"
          ></colored-icon>
          {{ trans('models.setting-groups.data.name.' + settingGroup.ucid) }}
        </Link>
      </li>
<!--      <template v-if="model.data.id">-->
<!--        <template v-for="(collection, name) in model.data.collections" :key="name">-->
<!--          <li v-if="meta.editable.includes(name)" class="nav-item">-->
<!--            <button :class="focus === name ? 'active' : 'text-muted'" class="nav-link" @click="setFocus(name)">-->
<!--              {{ trans(`models.settings.relations.${name}`) }}-->
<!--            </button>-->
<!--          </li>-->
<!--        </template>-->
<!--      </template>-->
    </ul>
    <div v-if="model.data && focus === 'self'" class="card rounded-corner">
      <div class="card-body">
        <div class="row g-3 mb-2 mt-0">
          <div v-if="model" class="col-12">
            <div class="d-flex mb-2 w-100 justify-content-between align-items-start">
              <h5>Einstellungen: {{ model.data.attributes.name }}</h5>
              <div class="d-flex">
                <div class="align-self-end me-1">Stammt aus Modul:</div>
                <relation-link class="align-self-end" :value="model.data.relations.origin_module"></relation-link>
              </div>
            </div>
            <hr class="border-1">
            <settings-form
              :settings="model.data.collections.settings"
              :parent-model="model"
              @update:toasts="addToasts(toasts)"
            ></settings-form>
          </div>
        </div>
      </div>
    </div>
    <template #right>
      <admin-sidebox :resource="model"></admin-sidebox>
    </template>
  </Layout>
</template>

<script>
import Card from '@kanrisha/components/Base/Card';
import Layout from '@kanrisha/Pages/Layout';
import ResourceForm from '@kanrisha/components/ResourceForm';
import ResourceActionButtons from '@kanrisha/components/Links/ResourceActionButtons';
import ResourceCollection from '@kanrisha/components/ResourceCollection';
import ResourceSelection from '@kanrisha/components/ResourceSelection';
import useModels from '@kanrisha/composables/useModels';
import { ref } from 'vue';
import { Link, router } from '@inertiajs/vue3';
import useResource from '@kanrisha/composables/useResource';
import useToasts from '@kanrisha/composables/useToasts';
import AdminSidebox from '@kanrisha/components/Layout/AdminSidebox';
import PickedResourceCard from '@kanrisha/components/Cards/PickedResource';
import RelationCollectionCard from '@kanrisha/components/Cards/RelationCollection';
import ResourceActionHeader from '@kanrisha/components/Layout/ResourceActionHeader';
import FormField from "@kanrisha/components/Form/FormField";
import ColoredIcon from "@kanrisha/components/Icons/ColoredIcon";
import RelationLink from "@kanrisha/components/Elements/Display/RelationLink";
import SettingsForm from "@/aspects/admin/components/Setting/SettingsForm";

export default {
  components: {
    SettingsForm,
    RelationLink,
    ColoredIcon,
    FormField,
    AdminSidebox,
    Card,
    Layout,
    Link,
    PickedResourceCard,
    RelationCollectionCard,
    ResourceActionButtons,
    ResourceActionHeader,
    ResourceCollection,
    ResourceForm,
    ResourceSelection,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    settings: { type: Object, default: () => {} },
    logEntries: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  emits: ['update:toast'],
  setup(props) {
    const { meta, resourceType } = useResource(props, props.model);
    const { addToasts } = useToasts(props);
    const focus = ref(props.model.meta.adjustments.focus ?? 'self');

    const setFocus = (name) => {
      const { focus: setFocusAdjustment } = useModels({ resourceType: 'setting-group' });
      setFocusAdjustment(props.model.meta.resourceType, name);
      focus.value = name;
    };

    const saveSetting = (setting) => {
      let { storeModel } = useModels({ resourceType: 'settings' });
      storeModel(setting, 'settings');
    }

    const updateMedia = (setting, mediaItems) => {
      setting.media = mediaItems;
      setting.data.attributes.media_ids = mediaItems.filter((item) => !item.remove).map((item) => item.id);
      setting.data.attributes.remove_media_ids = mediaItems
        .filter((item) => item.remove)
        .map((item) => item.id);
    };

    return {
      addToasts,
      focus,
      meta,
      resourceType,
      saveSetting,
      setFocus,
      updateMedia,
    };
  },
};
</script>

<style type="text/css">
  .media-container {
    max-width: 100%;
  }
</style>